//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum } from './Enums';

export class ExternalCalendarFeedUpdateItem extends ItemBase {
    Name?: string | null;
    URL?: string | null;
    Color?: EventColorEnum;
    Enabled?: boolean;

    constructor(initializer?: Partial<ExternalCalendarFeedUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ExternalCalendarFeedUpdateItem";
}
